// Aeflor.jsx (CORRIGIDO)
import React, { useEffect, useState, useContext } from "react";
// Importamos useNavigate para o redirecionamento
import { Link, useNavigate } from "react-router-dom";
import AeflorCard from "./../Components/AeflorCard/index.jsx";
import './index.css';
import { api } from './../../services/api.js';
import Loading from "../../comum/Layout/loading.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import { AuthContext } from '../../comum/Context/auth.jsx';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from '../../comum/Footer/index.jsx';
import Aniversario from './aniversario.jsx';

function Aeflor() {
    const { logado } = useContext(AuthContext);

    // Estados
    const [tabelas, setTabelas] = useState([]);
    const [comprador, setComprador] = useState(0);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [aprovacao, setAprovacao] = useState(false);
    const [negacao, setNegacao] = useState(false);
    const [confirmacaoId, setConfirmacaoId] = useState('');
    const [atualizado, setAtualizado] = useState('');
    const [nome, setNome] = useState('');
    const [erro, setErro] = useState('');
    const [datahora, setData] = useState('');
    const [sucesso, setSucesso] = useState(true);
    const [funcionarios, setFuncionarios] = useState(0);
    const [dependentes, setDependentes] = useState(0);

    // ESTADOS PARA O MODAL DE IMAGEM GLOBAL
    const [modalImageUrl, setModalImageUrl] = useState(null);
    const [modalTitle, setModalTitle] = useState('');

    const chapa = localStorage.getItem("chapa");
    const codevento = localStorage.getItem("codevento");
    // const usuario = chapa; // Variável 'usuario' não está sendo usada, pode ser removida se não for necessária


    // 1. Função para abrir o modal
    const openImageModal = (imageUrl, title) => {
        setModalImageUrl(imageUrl);
        setModalTitle(title);
    };

    // 2. Função para fechar o modal
    const closeImageModal = () => {
        setModalImageUrl(null);
        setModalTitle('');
    };

    // CORREÇÃO: O primeiro useEffect para verificação do chapa (agora com chaves fechadas)
    /* useEffect(() => {
         // localizar loja automaticamente
         if (!chapa) {
             navigate("/arbor/login");
         }
     }, [chapa, navigate]); */// Adiciona dependências para evitar warnings

    // CORREÇÃO: Variáveis de estado de classe (state/handleClick) removidas ou adaptadas, pois não são necessárias em Hooks
    // let state = { mostrarComponente: false }; 
    // function handleClick() { /* ... */ } 


    // 3. useEffect principal para o fetch de dados
    useEffect(() => {
        setRemoveLoading(false)
        setErro('');
        api.get('aeflor/evento/', {
            params: {
                // O nome do parâmetro na URL: O valor da variável
                matricula: chapa
            }
        })
            .then(response => {
                setTabelas(response.data);
                setRemoveLoading(true);
                console.log(response.data);
            })
            .catch(err => {
                setRemoveLoading(true);
                setErro(err.response.data.erro);
            });
    }, []); // Array de dependências vazio para rodar apenas uma vez na montagem

    return (
        <div>
            <Menu modulo="ARBOR" />
            <div className="aeflor-container">

                {/* O MODAL DE IMAGEM ESTÁ AQUI (Renderizado fora do card) */}
                {modalImageUrl && (
                    <div className="image-modal" onClick={closeImageModal}>
                        {/* O clique no span garante que feche mesmo que o clique venha da imagem (caso a imagem tenha outro handler) */}
                        <span className="modal-close" onClick={closeImageModal}>&times;</span>
                        <img className="modal-content" src={modalImageUrl} alt={modalTitle} />
                    </div>
                )}

                {!removeLoading && <Loading />}
                <div className="row justify-content-center">
                    {
                        tabelas.map((tabela) => {
                            return <div className="col-lg-10 col-md-12 col-sm-12 col-12" key={tabela.codevento}>
                                <AeflorCard
                                    chapa={chapa}
                                    codevento={tabela.codevento}
                                    descricao={tabela.descricao}
                                    nomeevento={tabela.nomeevento}
                                    status={tabela.status}
                                    dataevento={tabela.dataevento}
                                    inscinicio={tabela.inscinicio}
                                    inscfim={tabela.inscfim}
                                    erro={tabela.erro}
                                    fotolink={tabela.fotolink}
                                    funcionarios={tabela.funcionario}
                                    dependentes={tabela.dependente}
                                    inscrito={tabela.codigo}

                                    // PASSA A FUNÇÃO PARA O CARD CHAMAR
                                    onImageClick={openImageModal}
                                />
                            </div>;
                        })
                    }
                </div>
            </div>
            {removeLoading && <Footer className="footer navbar-fixed-bottom" />}
        </div>
    );
}

export default Aeflor;